import React, { useState, useEffect } from "react" 
import { useParams, useNavigate } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { parseContent } from "lib/render/parseContent"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import { useRenderStatement } from "."
import { queryTools, cn } from "lib/utils"
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function RenderStatement({ elemtype="opening_statements", statement }:{ elemtype?:string; statement:any }){
  const navigate = useNavigate()
  const { tmplid } = useParams()
  const { store, AppStore } = appStore()
  const { update } = AppStore

  const { data:_Apidata } = queryTools.resource.parseQueryForApi("apidata.findAll", {})

  const { generateStatementReport } = useRenderStatement()

  const { clientApiData }:any = useTemplatePreviewCtx() 
  
  const [ showReportData, setShowReportData ] = useState<boolean>(true)
  const [ statementReportData, setStatementReportData ] = useState<any>()
  const [ contentToDisplay, setContentToDisplay ] = useState<any>(undefined)
  const [ nestedStatementType, setNestedStatementType ] = useState<any>(undefined)
  const [ reportState, setReportState ] = useState<any>({ visibleZone: 0, visibleGroup: -1, visibleItem: -1 })

  const getContentToDisplay = (zonesFailed:number) => {
    if( zonesFailed === 0 && statement.if_passes.includes("content") ) {
      console.log('PASSED', statement.content.pass)
      setContentToDisplay(parseContent({ content: statement.content.pass, clientDataObj: clientApiData, apiData: _Apidata }).result)
    } else if (zonesFailed > 0 && statement.if_fails.includes("content") ) {
      // console.log('FAILED', statement.content.fail)
      setContentToDisplay(parseContent({ content: statement.content.fail, clientDataObj: clientApiData, apiData: _Apidata }).result)
    } else {
      setContentToDisplay(null)
    }
  }

  const getNestedStatementType = (zonesFailed:number) => {
    if( zonesFailed === 0 && statement.if_passes.includes("statement") ) {
      setNestedStatementType(statement.nested.if_passes)
    } else if ( zonesFailed > 0 && statement.if_fails.includes("statement") ) {
      setNestedStatementType(statement.nested.if_fails)
    } else {
      setNestedStatementType(null)
    }
  }

  const getStatementReport = () => {
    const report = generateStatementReport(statement, clientApiData) 
    // if( elemtype === "compelling_evidence" ) {
    //   console.log(report)
    // }
    // filter out any groups that have no items
    report.zones.forEach( (zone:any) => {
      zone.groups = zone.groups.filter( (group:any) => group.items.length > 0 )
    })

    setStatementReportData(report)
    getContentToDisplay(report.zonesFailed)
    getNestedStatementType(report.zonesFailed)
  }

  const parseResults = (passed:any[], failed: []) => {
    // console.log(failed)
    let passedData = []
    let failedData = []
    passed.forEach( (zoneObj:any) => {
      const groups = zoneObj.groups
      groups.forEach( (groupObj:any) => {
        const itemrefstr = groupObj.items
        const itemObj = statement.conditional.items.find( (item:any) => item.refid === itemrefstr )
        console.log(itemObj)
      })
    })
    failed.forEach( (zoneObj:any) => {
      // console.log('FAILED ZONE OBJ', zoneObj)
      const groups = zoneObj.groups
      groups.forEach( (groupObj:any) => {
        const items = groupObj.items
        items.forEach( (itemrefstr:any) => {
          const itemObj = statement.conditional.items.find( (item:any) => item.refid === itemrefstr )
          console.log(itemObj)
        })
      })
    })
  }

  const handleStatementClick = () => {
    update("actives.statement", statement)
    navigate(`/template/${tmplid}/build?elem=${elemtype}&statement=${statement.refstr}`)
  }

  const outerStyling = useRenderStyling("mm-statement w-full relative", "styleObj")
  const innerStyling = useRenderStyling("w-full flex flex-col", "styleObj")
  const borderStyling = useRenderStyling(cn(
    "m-0 mb-2",
    store.preview.display === "preview" && store.viewmode !== "pdf" && "cursor-pointer"
  ), "styleObj")

  useEffect(() => {
    getStatementReport()
  },[])

  if( contentToDisplay === undefined || contentToDisplay?.length > 0 && nestedStatementType === undefined ) return <></>
  return (
    <div {...outerStyling}>      

      <div {...innerStyling}>
        { contentToDisplay !== undefined && contentToDisplay !== null && contentToDisplay?.length > 0 && (
          <span 
            onClick={ store.preview.display === "preview" ? handleStatementClick : undefined }
            {...borderStyling}
            dangerouslySetInnerHTML={{ __html: contentToDisplay }} 
          />
        )}


        {/* { store.preview.reports === true && statementReportData !== undefined && (
          <StatementReport reportData={statementReportData} />
        )} */}

        { nestedStatementType !== undefined && nestedStatementType !== null && (
          <RenderStatement statement={nestedStatementType} />
        )}
      </div>
    </div>
  )
}